import React, { Component } from 'react';
import styled from 'styled-components';
import { GlobalStyle, Colors, ImageStyle } from 'stylecomponents';
import BreadCrumbs from 'components/commons/BreadCrumbs';
import Counter from 'components/commons/Counter';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actionCreators from 'actions/creators';
import moment from 'moment';
import GLOBAL from 'nonnglobal';
import CupoyImage from 'components/commons/CupoyImage';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';
import CupoyNoteContent from '../commons/CupoyNoteContent';
import MarkdownContentView from 'cupoy-md-editor/lib/preview';

const Container = GlobalStyle.BasicBlock.extend`
  height: 412px;
  padding: 30px;
`;

const Main = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${GlobalStyle.ViewSpace}px;
`;

const ContentImg = ImageStyle.extend`
  width: 300px;
  height: 225px;
  margin-right: 30px;
`;
const ContentWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;
const Footer = GlobalStyle.BasicBlock.extend`
  margin-top: ${GlobalStyle.ViewSpace}px;
`;

const Header = styled.div`
  border-bottom: solid 1px #D9D9D9;
  padding: 0 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const ProductName = styled.div`
  font-size: 20px;
  line-height: 1.25em;
  color: ${Colors.Dark3};
  font-weight: bold;
`;
const ProductLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer nofollow',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 55px;
  display: flex;
  margin-left: 4px;
  color: #F75C2F;
  font-size: 17px;

  > i {
    font-size: 20px;
    margin-right: 4px;
  }
`;
const FooterHeader = Header.extend`
    font-size: 20px;
    color: #4A4A4A;
    padding: 20px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${props => props.border ? 'solid 1px #D9D9D9' : 'none'};
  padding: 20px 0;
`;

const Text = styled.div`
  font-size: 14px;
  color: ${Colors.Dark3};
  letter-spacing: 0;
  margin-top: ${props => props.margin ? props.margin : 0}px;
  font-weight: ${props => props.bold ? 'bold' : ''};
`;

const Span = styled.span`
  font-weight: ${props => props.bold ? 'bold' : ''};
  color: ${props => props.color ? props.color : Colors.Dark3};
  font-size: ${props => props.fontSize ? props.fontSize : 14}px;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  padding: ${props => props.padding ? '20px' : 0};
  align-items: ${props => props.center ? 'center' : ''};
  margin-top: ${props => props.margin ? props.margin : 0}px;
`;

const ClickButton = styled.div`
  background-color: #F75C2F;
  border-radius: 5px;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0;
  padding: 12px 32px;
  margin-right: ${GlobalStyle.ViewSpace}px;
  cursor: pointer;
`;

const CartButton = styled.div`
  border: 1px solid #F75C2F;
  border-radius: 3px;
  font-size: 16px;
  color: #F75C2F;
  letter-spacing: 0;
  padding: 12px 32px;
  cursor: pointer;
`;

const Icon = styled.i`
  font-size: 20px;
  color: ${props => props.highlight ? '#F75C2F' : Colors.Dark3};
  margin-right: 3px;
`;
const LimitedContent = styled.div `
    margin-bottom: 16px;
    font-size: 13px;
    color: #777777;
`;

const NoLogin = styled.a`
  cursor: pointer;
`;

const StatusContainer = GlobalStyle.BasicBlock.extend`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;

class ProductContentView extends Component {

  constructor(props) {
    super(props);

    this.fetchProductInfo = this.fetchProductInfo.bind(this);
    this.showSignInDialog = this.showSignInDialog.bind(this);
    this.addCart = this.addCart.bind(this);
    this.buyFree = this.buyFree.bind(this);
    this.buyBonus = this.buyBonus.bind(this);
    this.getBreadCrumbsPath = this.getBreadCrumbsPath.bind(this);

    this.state = {
      quantity: 1,
      isError: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    // check後台發財商城開放狀態
    this.checkWebState();
    this.fetchProductInfo();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.productid !== this.props.productid) {
      this.fetchProductInfo();
    }
    if(prevProps.haslogin !== this.props.haslogin){
      this.fetchProductInfo()
    }
  }

  checkWebState = () => {
    this.props.webActions.checkWebState();
  }

  fetchProductInfo() {
    window.scrollTo({ top: 0 });

    const {
      productid,
    } = this.props;

    this.props.cardActions.getProductInfo({
      productid
    }).catch(error => {
      if (error.code === 'error.notAllowBoughtError') {
        this.setState({
          isError: true,
          errorMessage: error.message,
        });
      }
    });
  }

  addTradeNumber = () => {
    if (this.state.quantity === 10) return;
    this.setState(prevState => (
      { quantity: prevState.quantity + 1 }
    ));
  }

  minusTradeNumber = () => {
    if (this.state.quantity === 1) return;
    this.setState(prevState => (
      { quantity: prevState.quantity - 1 }
    ));
  }

  handleCountChange = event => {

    const { quantity } = this.state;
    const value = +event.target.value;

    if (Object.is(value, NaN)) {
      return;
    }

    if(value === quantity) return;

    if(value > 10) {
      this.setState({ quantity: 10 });
      return;
    }

    this.setState({ quantity: value });
  }

  showSignInDialog (event){
    event.preventDefault();
    this.props.webActions.showSignInDialog();
  }

  addCart() {

    const {
      productid,
    } = this.props;

    const {
      quantity,
    } = this.state;

    const {
      cardCartActions,
      cardProductMap,
      haslogin,
    } = this.props;

    if(!haslogin){
      this.props.webActions.needLogin();
      return;
    }

    if(quantity > 10) {
      this.props.webActions.openAlertDialog({
          title: '商品加入購物車失敗',
          description: '商品數量最多不得超過10',
      });
      return;
  }

    const { addCardToCart } = cardCartActions;
    const product = cardProductMap[productid];
    const { memberprice } = product;
    
    const totalPrice = quantity * memberprice;

    addCardToCart({
      productid: productid, count: quantity
    }).then(() => {
      this.props.webActions.openAlertDialog({
        title: '商品成功加入購物車',
        description: `數量:${quantity}\n總價:${totalPrice}`,
        closeCallback: () => 
          this.props.webActions.cupoyStateGo(
            CupoyRouter.STATES.MEMBER_CART
          )
      });
    }, (error) => {

      let errorMsg = '發生無法預期的錯誤';
      let errorDescription = '';

      if (error && error.code) {
          switch (error.code) {
            case 'error.privilege.noLogin':
              return;
            default:
                errorMsg = error.message;
              break;
          }
      }

      this.props.webActions.openAlertDialog({
        title: errorMsg, description: errorDescription
      });
    })
  }

  buyFree() {

    const {
      productid,
      cardProductMap,
      haslogin,
      memberinfo,
    } = this.props;

    if(!haslogin) {
      this.props.webActions.needLogin();      return;
    }

    const {
      idnumber,
      issmsauth,
      isemailauth,
    } = memberinfo;

    if(!idnumber) {
      this.props.webActions.openAlertDialog({
        title: '發生錯誤',
        description: '身分證未驗證',
      });
      return;
    }

    if(!issmsauth) {
      this.props.webActions.openAlertDialog({
        title: '發生錯誤',
        description: '行動電話未驗證',
      });
      return;
    }

    if(!isemailauth) {
      this.props.webActions.openAlertDialog({
        title: '發生錯誤',
        description: '電子信箱未驗證',
      });
      return;
    }

    const product = cardProductMap[productid];
    const { jsdproductid } = product;

    const payload = {
      productid,
      count: 1,
      jsdproductid,
    };

    this.props.cardOrderActions.buyFreeCardProduct(payload).then(() => {
      this.props.webActions.openAlertDialog({
        title: '成功購買商品',
        description: `跳轉至訂單記錄`,
        closeCallback: () => this.props.webActions.cupoyStateGo(
            CupoyRouter.STATES.MEMBER_CARD_ORDER_LIST_FINISH
          )
      });
    }).catch((err) => {
      this.props.webActions.openAlertDialog({
        title: '發生錯誤',
        description: err.message,
      });
    });
  }

  buyBonus() {

    const {
      productid,
      cardProductMap,
    } = this.props;

    const product = cardProductMap[productid];
    const { jsdproductid } = product;

    this.props.webActions.openBuyBonusPdtDialog(
      productid,
      jsdproductid
    );
  }

  getBreadCrumbsPath(product) {

    const { productname = '', productclassid } = product;

    let preTitle = '', preState = '';

    switch (productclassid) {
      case GLOBAL.PRODUCT_CLASS_ID.POINTCARD_PRODUCT:
        preState = CupoyRouter.STATES.POINTCARD;
        preTitle = '點數卡';
        break;
      case GLOBAL.PRODUCT_CLASS_ID.VITEM_PRODUCT:
        preState = CupoyRouter.STATES.VITEMPRODUCTS;
        preTitle = '虛寶包';
        break;
      case GLOBAL.PRODUCT_CLASS_ID.FREE_PRODUCT:
        preState = CupoyRouter.STATES.FREEPRODUCTS;
        preTitle = '免費索取';
        break;
      case GLOBAL.PRODUCT_CLASS_ID.BONUS_PRODUCT:
        preState = CupoyRouter.STATES.BONUSPRODUCTS;
        preTitle = '發財商城';
        break;
      default:
        break;
    }

    const path = {
      preState,
      preTitle,
      title: productname.trim(),
    };

    return path;
  }

  renderError = () => {
    return (
      <StatusContainer>
        <GlobalStyle.ErrorContainer>
          <GlobalStyle.ErrorContainerTitle>
            {this.state.errorMessage}
          </GlobalStyle.ErrorContainerTitle>
        </GlobalStyle.ErrorContainer>
      </StatusContainer>
    );
  };

  render() {

    const {
      productid,
      cardProductMap,
      BONUSMALL,
    } = this.props;

    const {
      isError,
      quantity,
    } = this.state;

    const product = cardProductMap[productid];

    if(!product && !isError) 
      return this.renderLoading();

    if (isError) {
      return this.renderError();
    }

    const {
      productname = '',
      marketprice,
      memberprice,
      productinfo,
      islimited,
      thumbimg,
      productclassid,
      producturl,
      updatetime,
      note_editor_type,
      markdown
    } = product;

    const path = this.getBreadCrumbsPath(product);

    const isFreeProduct = productclassid === GLOBAL.PRODUCT_CLASS_ID.FREE_PRODUCT;
    const isBonusProduct = productclassid === GLOBAL.PRODUCT_CLASS_ID.BONUS_PRODUCT;

    if(isBonusProduct && !BONUSMALL) {
      return (
        <div>
          <StatusContainer>
            <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                發財商城暫停使用中
              </GlobalStyle.ErrorContainerTitle>
            </GlobalStyle.ErrorContainer>
          </StatusContainer>
        </div>
      );
    }

    const buyFreeFunc = isFreeProduct ?
                        this.buyFree
                        : 
                        isBonusProduct ?
                          this.buyBonus
                          :
                          undefined;

    const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg, updatetime);

    return (
      <div>
        <Container>
          <BreadCrumbs path={path} />
          <Main>
            <CupoyImage
              isBackgroundImage
              stylecomponent={ContentImg}
              src={imageSrc}
            />
            <ContentWrapper>

              <Header>
                <ProductName>
                  {productname.trim()}
                </ProductName>
                {!!producturl && (
                  <ProductLink href={producturl}>
                    <i className='zmdi zmdi-home'></i>
                    官網
                  </ProductLink>
                )}
              </Header>

              <Content border>
                <Text bold>{`商品市價： ${marketprice} 元`}</Text>
                <Text margin={GlobalStyle.ViewSpace} bold>
                  會員售價：
                  <Span color={Colors.MAIN_COLOR}>
                    {` ${memberprice} `}
                    {isBonusProduct ? '發財金' : '元'}
                    </Span>
                </Text>
                {!isFreeProduct && !isBonusProduct && (
                  <Flex center margin={GlobalStyle.ViewSpace}>
                    <Text bold>購買數量： </Text>
                    <Counter
                      number={this.state.quantity}
                      add={this.addTradeNumber}
                      minus={this.minusTradeNumber}
                      handleChange={this.handleCountChange}
                    />
                  </Flex>
                )}
              </Content>
              <Content>
                <Text bold>總價：
                  <Span fontSize={28} color={Colors.MAIN_COLOR}>
                    {quantity * memberprice}
                  </Span>
                  <Span color={Colors.MAIN_COLOR}>
                    {isBonusProduct ? ' 發財金' : ' 元'}
                  </Span>
                </Text>
                <Flex margin={GlobalStyle.ViewSpace}>
                  {isFreeProduct
                    ? <ClickButton onClick={buyFreeFunc}>立即索取</ClickButton>
                    : isBonusProduct
                      ? <ClickButton onClick={buyFreeFunc}>立即兌換</ClickButton>
                      : (
                        <CartButton onClick={this.addCart}>
                          <Icon className="zmdi zmdi-shopping-cart" highlight />
                          加入購物車
                        </CartButton>
                      )
                  }
                </Flex>
              </Content>
            </ContentWrapper>
          </Main>
        </Container>
        <Footer>
          <FooterHeader>商品詳情</FooterHeader>
          <Flex column padding>
            {islimited && this.renderLimitedContent()}
            {note_editor_type === 1 ?
                <MarkdownContentView mdcontent={markdown} />      
                : <CupoyNoteContent html={productinfo} />
            }
            {/* <CupoyNoteContent html={productinfo} /> */}
            {this.props.isloading && this.renderLoading()}
          </Flex>
        </Footer>
      </div>
    )
  }

  renderLimitedContent = () => {
    const {
      productid,
      cardProductMap,
      haslogin,
    } = this.props;

    const product = cardProductMap[productid];

    const {
      buyterm,
      buycnt,
      lastbuytime,
      canbuy,
      buytermval,
    } = product;

    let str;
    
    const lastBuyTimeInMoment = moment(lastbuytime).format('YYYY-MM-DD')
    const lastBuyTimeText = lastbuytime > 0 ? `上次購買時間: ${lastBuyTimeInMoment} <br />` : ''

    const availibleNumTextForUser = `<span style="color:#FA0300;">${canbuy}</span>`
    const textWhenNotLoggedIn = `<span style="color:#FA0300;text-decoration:underline;">您尚未登入</span>`
    const availibleNumTextToShowForUser = haslogin ? availibleNumTextForUser : textWhenNotLoggedIn

    if (buyterm === 1) {
      str = `本商品為限定商品，1個月內，購買數量限制為 :  ${buycnt} <br />
      ${lastBuyTimeText}
      您目前可購買剩餘數量 : ${availibleNumTextToShowForUser} `;
    }
    if (buyterm === 2) {
      str = `本商品為限定商品，1天內購買數量限制為 :  ${buycnt} <br />
      ${lastBuyTimeText}
      您目前可購買剩餘數量 : ${availibleNumTextToShowForUser} `;
    }
    if (buyterm === 3) {
      str = `本商品為限定商品，7天內購買數量限制為 :  ${buycnt} <br />
      ${lastBuyTimeText}
      您目前可購買剩餘數量 : ${availibleNumTextToShowForUser} `;
    }
    if (buyterm === 4) {
      str = `本商品為限定商品， ${buytermval} 天內購買數量限制為 :  ${buycnt} <br />
      ${lastBuyTimeText}
      您目前可購買剩餘數量 : ${availibleNumTextToShowForUser} `;
    }

    return (
      <LimitedContent>
        {
          haslogin 
          ? 
          <div dangerouslySetInnerHTML={{ __html: str }} />
          :
          <NoLogin onClick={this.showSignInDialog}
            dangerouslySetInnerHTML={{ __html: str }}
          />
        }
      </LimitedContent>
    );
  }

  renderLoading = () => {
    return (
      <GlobalStyle.LoadingContainer>
        <GlobalStyle.Spin />
      </GlobalStyle.LoadingContainer>
    );
  }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    cardProductMap: state.card.cardProductMap,
    haslogin: state.member.haslogin,
    isloading: state.card.isloading,
    BONUSMALL: state.web.BONUSMALL,
    memberinfo: state.member.memberinfo,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    cardActions: bindActionCreators(actionCreators.cardActionCreators, dispatch),
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    cardCartActions: bindActionCreators(actionCreators.cardCartActionCreators, dispatch),
    cardOrderActions: bindActionCreators(actionCreators.cardOrderActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps)(ProductContentView);
